module.exports = __webpack_public_path__ + "static/media/weather-app.2613959e.png";